module.exports = __webpack_public_path__ + "fonts/fa-regular-400.ad3a7c0d.eot";